import { useEffect, useState } from "react";

import {
    MapPin,
    Save
} from "lucide-react";

import Card from "../shared/Card";
import Button from "../shared/Button";

export default function AddressCard({

    address,

    onSave

}){

    const [form,setForm]=useState({

        line1:"",
        line2:"",
        city:"",
        state:"",
        pincode:""

    });

    useEffect(()=>{

        if(address){

            setForm({

                line1:address.line1||"",

                line2:address.line2||"",

                city:address.city||"",

                state:address.state||"",

                pincode:address.pincode||""

            });

        }

    },[address]);

    function update(key,value){

        setForm(previous=>({

            ...previous,

            [key]:value

        }));

    }

    async function save(){

        await onSave?.(form);

    }

    return(

        <Card className="crm-address-card">

            <div className="crm-card-title">

                <MapPin size={18}/>

                <span>

                    Address

                </span>

            </div>

            <div className="crm-address-grid">

                <input

                    placeholder="Address Line 1"

                    value={form.line1}

                    onChange={e=>

                        update(

                            "line1",

                            e.target.value

                        )

                    }

                />

                <input

                    placeholder="Address Line 2"

                    value={form.line2}

                    onChange={e=>

                        update(

                            "line2",

                            e.target.value

                        )

                    }

                />

                <input

                    placeholder="City"

                    value={form.city}

                    onChange={e=>

                        update(

                            "city",

                            e.target.value

                        )

                    }

                />

                <input

                    placeholder="State"

                    value={form.state}

                    onChange={e=>

                        update(

                            "state",

                            e.target.value

                        )

                    }

                />

                <input

                    placeholder="Pincode"

                    value={form.pincode}

                    onChange={e=>

                        update(

                            "pincode",

                            e.target.value

                        )

                    }

                />

            </div>

            <div className="crm-address-footer">

                <Button

                    icon={<Save size={16}/>}

                    onClick={save}

                >

                    Save Address

                </Button>

            </div>
<style>{`.crm-address-card{

    display:flex;

    flex-direction:column;

    gap:20px;

}

.crm-card-title{

    display:flex;

    align-items:center;

    gap:10px;

    font-size:18px;

    font-weight:600;

}

.crm-address-grid{

    display:grid;

    grid-template-columns:1fr 1fr;

    gap:14px;

}

.crm-address-grid input{

    width:90%;

    padding:12px;

    border:1px solid #ddd;

    border-radius:8px;

    outline:none;

}

.crm-address-grid input:focus{

    border-color:#2563eb;

}

.crm-address-footer{

    display:flex;

    justify-content:flex-end;

}

@media(max-width:768px){

.crm-address-grid{

    grid-template-columns:1fr;

}

}`}</style>
        </Card>

    );

}